<div class="flex flex-col gap-4">
  <div class="warningMessage flex flex-row gap-4" *ngIf="warningMessage !== ''">
    <ion-icon icon="/assets/icon/alert-yellow.svg"></ion-icon>
    <span>{{ warningMessage }}</span>
  </div>
  <div class="warningMessage flex flex-row gap-4" *ngIf="isA3Binding">
    <ion-icon icon="/assets/icon/alert-yellow.svg"></ion-icon>
    <span>
      Actualmente solo es posible encuadernar con anillas los papeles tipo cartulina (gramajes 200 y 300) en formato A3,
      sin tapas. Próximamente incorporaremos más gramajes y tapas de colores
    </span>
  </div>
  <!-- OPCION INDIVIDUAL -->
  <mat-grid-list
    *ngIf="
      !printingGroup.printSettings.grouped ||
      (printingGroup.printSettings.grouped &&
        printingGroup.printSettings.finishing !== Finishing.BINDING &&
        printingGroup.printSettings.finishing !== Finishing.BINDING_LAMINATED)
    "
    cdkDropListGroup
    cols="12"
    [rowHeight]="rowHeight"
    gutterSize="20px"
  >
    <mat-grid-tile
      cdkDropList
      cdkDropListOrientation="vertical"
      [cdkDropListData]="i"
      *ngFor="let pFile of printingGroup?.files; index as i"
      [colspan]="fileColspan"
      rowspan="1"
    >
      <div
        cdkDrag
        [cdkDragDisabled]="isLoading"
        [cdkDragPreviewClass]="'file-drag-preview'"
        [cdkDragData]="i"
        (cdkDragDropped)="drop($event)"
        (cdkDragEntered)="dragEnter($event)"
        (cdkDragExited)="dragExit($event)"
        class="file-container"
      >
        <app-file
          [index]="i"
          [file]="files[i]"
          [pFile]="pFile"
          [printingGroup]="printingGroup"
          [settingsChanged]="settingsChanged"
          [isLoading]="isLoading"
          [printProductId]="printProductId"
          [printProduct]="printProduct"
          [settings]="settings"
          (fileAction)="_fileAction($event, i)"
          style="text-align: left"
        >
        </app-file>
        <app-file
          *cdkDragPreview
          [preview]="true"
          [index]="i"
          [file]="files[i]"
          [pFile]="pFile"
          [printingGroup]="printingGroup"
          [settingsChanged]="settingsChanged"
          [isLoading]="isLoading"
          [printProductId]="printProductId"
          [printProduct]="printProduct"
          [settings]="settings"
          (fileAction)="_fileAction($event, i)"
          style="text-align: left"
        >
        </app-file>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
  <!-- OPCION AGRUPADO -->
  <mat-grid-list
    *ngIf="
      printingGroup.printSettings.grouped &&
      (printingGroup.printSettings.finishing === Finishing.BINDING ||
        printingGroup.printSettings.finishing === Finishing.BINDING_LAMINATED)
    "
    cdkDropListGroup
    cols="12"
    [rowHeight]="appService.isMobile() ? '51px' : '50px'"
    gutterSize="0px"
  >
    <mat-grid-tile
      cdkDropList
      [cdkDropListData]="0"
      [colspan]="appService.isMobile() ? 12 : 6"
      [rowspan]="getRowspanForGroupedBinding()"
    >
      <ng-container *ngFor="let pFile of printingGroup?.files; index as i">
        <div
          *ngIf="i == 0"
          cdkDrag
          [cdkDragDisabled]="isLoading"
          [cdkDragPreviewClass]="'file-drag-preview'"
          [cdkDragData]="0"
          (cdkDragDropped)="drop($event)"
          class="file-container"
        >
          <app-file
            [index]="0"
            [file]="files[0]"
            [pFile]="printingGroup?.files[0]"
            [printingGroup]="printingGroup"
            [settingsChanged]="settingsChanged"
            [isLoading]="isLoading"
            [printProductId]="printProductId"
            [printProduct]="printProduct"
            [settings]="settings"
            (fileAction)="_fileAction($event, 0)"
            (hideGroupedFilesEvent)="toggleHideGroupedFiles($event)"
            style="text-align: left"
          >
          </app-file>
        </div>
      </ng-container>
    </mat-grid-tile>
    <mat-grid-tile
      *ngIf="printingGroup?.files.length > 1 && (!hideGroupedFiles || !appService.isMobile())"
      class="grouped-file-list"
      [colspan]="appService.isMobile() ? 12 : 6"
      [rowspan]="appService.isMobile() ? 4 * (files.length - 1) : getRowspanForGroupedBinding()"
      [ngStyle]="{
        transform: appService.isMobile() ? 'scaleX(1)' : {},
        'border-radius': appService.isMobile() ? '0 0 20px 20px' : '20px',
      }"
    >
      <span class="title">Orden de los documentos:</span>
      <ng-container *ngFor="let pFile of printingGroup?.files | slice: 1; index as i">
        <div cdkDropList [cdkDropListData]="i + 1" class="w-100">
          <div
            cdkDrag
            [cdkDragDisabled]="isLoading"
            [cdkDragPreviewClass]="'file-drag-preview'"
            [cdkDragData]="i + 1"
            (cdkDragDropped)="drop($event)"
            class="file-container"
          >
            <app-file
              [index]="i + 1"
              [reduced]="true"
              [file]="files[i + 1]"
              [pFile]="printingGroup?.files[i + 1]"
              [printingGroup]="printingGroup"
              [settingsChanged]="settingsChanged"
              [isLoading]="isLoading"
              [printProductId]="printProductId"
              [printProduct]="printProduct"
              [settings]="settings"
              (fileAction)="_fileAction($event, i + 1)"
              style="text-align: left"
            >
            </app-file>
          </div>
        </div>
      </ng-container>
    </mat-grid-tile>
  </mat-grid-list>
</div>
